export enum RouteKey {
  HOME = '/',
  DASHBOARD = '/dashboard',
  LOGIN = '/login',
  NewMandant = '/mandant/new',
  User = '/user',
  AddUser = '/user/add',
  EditProfile = '/user/profile',
  EditUser = '/user/:userId'
}
